module.exports = __webpack_public_path__ + "img/green_077.80dd558c.png";